import {
  FETCHING_EXHIBITION_THEMATIC_AREAS_REQUEST,
  FETCHING_EXHIBITION_THEMATIC_AREAS_SUCCESS,
  FETCHING_EXHIBITION_THEMATIC_AREAS_FAILURE,
  
  FETCHING_EXHIBITION_THEMATIC_AREA_REQUEST,
  FETCHING_EXHIBITION_THEMATIC_AREA_SUCCESS,
  FETCHING_EXHIBITION_THEMATIC_AREA_FAILURE,

  CREATE_EXHIBITION_THEMATIC_AREA_FAILURE,
  CREATE_EXHIBITION_THEMATIC_AREA_SUCCESS,
  CREATE_EXHIBITION_THEMATIC_AREA_REQUEST,

  UPDATE_EXHIBITION_THEMATIC_AREA_FAILURE,
  UPDATE_EXHIBITION_THEMATIC_AREA_SUCCESS,
  UPDATE_EXHIBITION_THEMATIC_AREA_REQUEST,

  DELETE_EXHIBITION_THEMATIC_AREA_FAILURE,
  DELETE_EXHIBITION_THEMATIC_AREA_SUCCESS,
  DELETE_EXHIBITION_THEMATIC_AREA_REQUEST,
  CLEAR_EXHIBITION_THEMATIC_AREA
} from '../actions/types';
import ResponseService from '../../utils/ResponseService';
import ApplicationError from '../../utils/ApplicationError';

const initialState = {
  thematicAreas: [],
  thematicArea: undefined,
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData()
};

const thematicAreasReducer = (state = initialState, action ) => {
  switch(action.type) {
    case FETCHING_EXHIBITION_THEMATIC_AREAS_REQUEST:
      return {...state, isFetching: true, thematicAreas: [] }
    case FETCHING_EXHIBITION_THEMATIC_AREAS_SUCCESS:
      return {...state, isFetching: false, 
        thematicAreas: action.payload.objects, 
        error: ApplicationError.buildDefault(),
        ...action.payload.paginationData }

    case FETCHING_EXHIBITION_THEMATIC_AREAS_FAILURE:
      return {...state, isFetching: false, error: action.payload }
    
    case FETCHING_EXHIBITION_THEMATIC_AREA_REQUEST:
      return {...state, isFetching: true }
    case FETCHING_EXHIBITION_THEMATIC_AREA_SUCCESS: 
      return {...state, isFetching: false, thematicArea: action.payload, error: ApplicationError.buildDefault() }
    case FETCHING_EXHIBITION_THEMATIC_AREA_FAILURE:
      return {...state, isFetching: false, error: action.payload }  

    case  CREATE_EXHIBITION_THEMATIC_AREA_REQUEST:
      return {...state, isFetching: true }
    case  CREATE_EXHIBITION_THEMATIC_AREA_SUCCESS:
      return {...state, isFetching: false, thematicArea: action.payload, error: ApplicationError.buildDefault() }
    case  CREATE_EXHIBITION_THEMATIC_AREA_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    case  UPDATE_EXHIBITION_THEMATIC_AREA_REQUEST:
      return {...state, isFetching: true }
    case  UPDATE_EXHIBITION_THEMATIC_AREA_SUCCESS:
      return {...state, isFetching: false, thematicArea: action.payload, error: ApplicationError.buildDefault() }
    case  UPDATE_EXHIBITION_THEMATIC_AREA_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    case  DELETE_EXHIBITION_THEMATIC_AREA_REQUEST:
      return {...state, isFetching: true }
    case  DELETE_EXHIBITION_THEMATIC_AREA_SUCCESS:
      return {...state, isFetching: false, error: ApplicationError.buildDefault() }
    case  DELETE_EXHIBITION_THEMATIC_AREA_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    case CLEAR_EXHIBITION_THEMATIC_AREA: 
        return {...initialState}

    default: 
      return state
  }
}

export default thematicAreasReducer;